import { normalizeScheduledTime } from "../services/socialTokenService";

/** Clock skew / “schedule in a few seconds” — after this, treat as future and defer to scheduler. */
const FUTURE_SCHEDULE_BUFFER_MS = 10_000;

export function parseScheduledDate(scheduledTime: string | undefined): Date | null {
  if (!scheduledTime?.trim()) return null;
  const d = new Date(normalizeScheduledTime(scheduledTime));
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Future-dated posts: rely on content DB + platform scheduler (same as saving schedule in
 * Manage Social Media). Do not call `/social/posts` — that path often publishes immediately.
 */
export function shouldDeferPublishToScheduler(scheduledTime: string | undefined): boolean {
  const d = parseScheduledDate(scheduledTime);
  if (!d) return false;
  return d.getTime() > Date.now() + FUTURE_SCHEDULE_BUFFER_MS;
}
